<template>
  <div class="containerVideoAvatarPreviewGenerator">
    <transition name="fade">
      <div
        class="avatarPreview"
        :class="avatarSelected"
        v-show="!isPreviewText2Speech"
      ></div>
    </transition>
    <transition name="fade">
      <video
        class="videoAvatarPreview"
        v-show="isPreviewText2Speech"
        ref="videoAvatarPreview"
        :src="transparentAvatarVideo"
        muted
      />
    </transition>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import { CREATE_TMP_CHUNK_VIDEO } from "@/store/media/mediaAction";
import { Slide } from "@/store/slides2Video/slides2VideoModels";
import { clone } from "@/utils/cloneUtil";
import { updateCurrentSlide } from "@/utils/slides/slideUtil";
import { AVATAR_SOURCE_BUCKET } from "@/store/conf/api";
import { AvatarStyle } from "@/store/AIAvatar/aiavatarGenerationModel";

@Component({})
export default class VideoAvatarPreview extends Vue {
  get avatarSelected() {
    return store.getters.getAvatarSelected;
  }
  get transparentAvatarVideo() {
    return (
      AVATAR_SOURCE_BUCKET +
      "/" +
      this.avatarSelected.toLowerCase() +
      "/" +
      this.avatarSelected +
      "_transparent.webm"
    );
  }
  get isPreviewText2Speech() {
    return store.getters.isPreviewSpeech2Text;
  }

  @Watch("isPreviewText2Speech")
  private controlVideoPlayer() {
    const videoPlayer = this.$refs["videoAvatarPreview"] as HTMLVideoElement;
    if (!videoPlayer) {
      return;
    }
    if (this.isPreviewText2Speech) {
      videoPlayer.currentTime = 0;
      videoPlayer.play();
    } else {
      videoPlayer.currentTime = 0;
      videoPlayer.pause();
    }
  }
}
</script>

<style lang="scss" scoped>
.containerVideoAvatarPreviewGenerator {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  .videoAvatarPreview {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatarPreview {
    animation-delay: 0.5s;
    position: absolute;
    border: solid 1px var(--light1);
    border-radius: 12px;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    // V2
    &.Abigail {
      background-image: url(@/assets/AIAvatar/ABIGAIL.png);
    }

    &.Andy {
      background-image: url(@/assets/AIAvatar/ANDY.png);
    }

    &.Arthur {
      background-image: url(@/assets/AIAvatar/ARTHUR.png);
    }

    &.Dan {
      background-image: url(@/assets/AIAvatar/DAN.png);
    }

    &.Dana {
      background-image: url(@/assets/AIAvatar/DANA.png);
    }

    &.Darnel {
      background-image: url(@/assets/AIAvatar/DARNEL.png);
    }

    &.Elia {
      background-image: url(@/assets/AIAvatar/ELIA.png);
    }

    &.Eva {
      background-image: url(@/assets/AIAvatar/EVA.png);
    }

    &.Faiza {
      background-image: url(@/assets/AIAvatar/FAIZA.png);
    }

    &.Hannah {
      background-image: url(@/assets/AIAvatar/HANNAH.png);
    }

    &.Isabella {
      background-image: url(@/assets/AIAvatar/ISABELLA.png);
    }

    &.Jad {
      background-image: url(@/assets/AIAvatar/JAD.png);
    }

    &.Jen {
      background-image: url(@/assets/AIAvatar/JEN.png);
    }

    &.Jessica {
      background-image: url(@/assets/AIAvatar/JESSICA.png);
    }

    &.John {
      background-image: url(@/assets/AIAvatar/JOHN.png);
    }

    &.Laura {
      background-image: url(@/assets/AIAvatar/LAURA.png);
    }

    &.Marc {
      background-image: url(@/assets/AIAvatar/MARC.png);
    }

    &.Marie {
      background-image: url(@/assets/AIAvatar/MARIE.png);
    }

    &.Martha {
      background-image: url(@/assets/AIAvatar/MARTHA.png);
    }

    &.Melie {
      background-image: url(@/assets/AIAvatar/MELIE.png);
    }

    &.Michelle {
      background-image: url(@/assets/AIAvatar/MICHELLE.png);
    }

    &.Mike {
      background-image: url(@/assets/AIAvatar/MIKE.png);
    }

    &.Mya {
      background-image: url(@/assets/AIAvatar/MYA.png);
    }

    &.Nelly {
      background-image: url(@/assets/AIAvatar/NELLY.png);
    }

    &.Olivia {
      background-image: url(@/assets/AIAvatar/OLIVIA.png);
    }

    &.Ruby {
      background-image: url(@/assets/AIAvatar/RUBY.png);
    }

    &.Ryan {
      background-image: url(@/assets/AIAvatar/RYAN.png);
    }

    &.Sarah {
      background-image: url(@/assets/AIAvatar/SARAH.png);
    }

    &.Steeve {
      background-image: url(@/assets/AIAvatar/STEEVE.png);
    }

    &.Stella {
      background-image: url(@/assets/AIAvatar/STELLA.png);
    }
    &.Lara {
      background-image: url(@/assets/AIAvatar/LARA.png);
    }
    &.Liam {
      background-image: url(@/assets/AIAvatar/LIAM.png);
    }
    &.Rosie {
      background-image: url(@/assets/AIAvatar/ROSIE.png);
    }
    &.Arabella {
      background-image: url(@/assets/AIAvatar/ARABELLA.png);
    }
    &.Talia {
      background-image: url(@/assets/AIAvatar/TALIA.png);
    }
  }
}
</style>
